export default __webpack_public_path__ + "img/PIC_HE_Shop_fw_de_de_92822.jpg";